// Mock response strategies data
export const mockStrategies = [
  {
    id: "strat-1",
    name: "Критические: стоп-слова",
    description: "Отзывы со стоп-словами (угрозы, оскорбления, юридические термины) отправляются на ручную модерацию",
    is_active: true,
    is_fallback: false,
    priority: 100,
    conditions: {
      operator: "AND",
      conditions: [
        { field: "has_stop_words", operator: "is", value: true }
      ]
    },
    generation_config: {
      mode: "manual",
      notify_slack: true,
      assign_to: "manager@artvisage.ru"
    },
    brands: ["Art-Visage", "Estrade"],
    sources: ["wildberries", "ozon"],
    matched_count: 8,
    last_matched_at: "2025-10-27T09:20:00Z",
    created_by: "user-1",
    created_at: "2025-10-20T10:00:00Z",
    updated_at: "2025-10-20T10:00:00Z",
  },
  {
    id: "strat-2",
    name: "Негативные отзывы с вопросами",
    description: "Негативные отзывы 1-3★ с вопросами требуют заботливого ответа с использованием RAG",
    is_active: true,
    is_fallback: false,
    priority: 90,
    conditions: {
      operator: "AND",
      conditions: [
        { field: "sentiment", operator: "equals", value: "negative" },
        { field: "has_question_mark", operator: "is", value: true },
        { field: "rating", operator: "<=", value: 3 }
      ]
    },
    generation_config: {
      mode: "ai",
      style: "заботливый",
      use_rag: true,
      rag_limit: 5,
      guardrails: ["standard", "extra_negative_check"],
      escalate_if_uncertain: true,
      escalation_threshold: 0.7
    },
    brands: ["Art-Visage", "Estrade"],
    sources: ["wildberries", "ozon"],
    matched_count: 24,
    last_matched_at: "2025-10-26T14:25:00Z",
    created_by: "user-1",
    created_at: "2025-10-20T10:00:00Z",
    updated_at: "2025-10-20T10:00:00Z",
  },
  {
    id: "strat-3",
    name: "Упоминание конкурентов",
    description: "Отзывы с упоминанием брендов-конкурентов отправляются на ручную проверку",
    is_active: true,
    is_fallback: false,
    priority: 85,
    conditions: {
      operator: "AND",
      conditions: [
        { field: "competitor_mention", operator: "is", value: true }
      ]
    },
    generation_config: {
      mode: "manual",
      notify_slack: true
    },
    brands: ["Art-Visage", "Estrade"],
    sources: ["wildberries", "ozon"],
    matched_count: 3,
    last_matched_at: "2025-10-31T10:15:00Z",
    created_by: "user-1",
    created_at: "2025-10-20T10:00:00Z",
    updated_at: "2025-10-20T10:00:00Z",
  },
  {
    id: "strat-4",
    name: "Вопросы о составе и применении",
    description: "Вопросы о продукте требуют детального ответа с использованием базы знаний",
    is_active: true,
    is_fallback: false,
    priority: 70,
    conditions: {
      operator: "AND",
      conditions: [
        { field: "has_question_mark", operator: "is", value: true },
        { field: "topics", operator: "in", value: ["вопрос_по_продукту", "выбор_тона", "состав", "применение"] }
      ]
    },
    generation_config: {
      mode: "ai",
      style: "профессиональный",
      use_rag: true,
      rag_limit: 3
    },
    brands: ["Art-Visage", "Estrade"],
    sources: ["wildberries", "ozon"],
    matched_count: 15,
    last_matched_at: "2025-10-28T11:45:00Z",
    created_by: "user-1",
    created_at: "2025-10-20T10:00:00Z",
    updated_at: "2025-10-20T10:00:00Z",
  },
  {
    id: "strat-5",
    name: "Только звезды 5★",
    description: "Отзывы с 5 звездами без текста - быстрый шаблонный ответ благодарности",
    is_active: true,
    is_fallback: false,
    priority: 50,
    conditions: {
      operator: "AND",
      conditions: [
        { field: "rating", operator: "equals", value: 5 },
        { field: "has_text", operator: "is", value: false }
      ]
    },
    generation_config: {
      mode: "template",
      template_set: "5_stars_thanks"
    },
    brands: ["Art-Visage", "Estrade"],
    sources: ["wildberries", "ozon"],
    matched_count: 89,
    last_matched_at: "2025-10-30T08:20:00Z",
    created_by: "user-1",
    created_at: "2025-10-20T10:00:00Z",
    updated_at: "2025-10-20T10:00:00Z",
  },
  {
    id: "strat-6",
    name: "Позитивные 4-5★ с текстом",
    description: "Позитивные отзывы с развернутым текстом - AI генерация с дружелюбным стилем",
    is_active: true,
    is_fallback: false,
    priority: 40,
    conditions: {
      operator: "AND",
      conditions: [
        { field: "rating", operator: ">=", value: 4 },
        { field: "has_text", operator: "is", value: true }
      ]
    },
    generation_config: {
      mode: "ai",
      style: "дружелюбный",
      use_rag: true
    },
    brands: ["Art-Visage", "Estrade"],
    sources: ["wildberries", "ozon"],
    matched_count: 45,
    last_matched_at: "2025-10-29T16:35:00Z",
    created_by: "user-1",
    created_at: "2025-10-20T10:00:00Z",
    updated_at: "2025-10-20T10:00:00Z",
  },
  {
    id: "strat-7",
    name: "Негативные без вопросов",
    description: "Негативные отзывы без вопросов - заботливый ответ с извинениями",
    is_active: true,
    is_fallback: false,
    priority: 30,
    conditions: {
      operator: "AND",
      conditions: [
        { field: "rating", operator: "<=", value: 3 },
        { field: "has_question_mark", operator: "is", value: false },
        { field: "has_stop_words", operator: "is", value: false }
      ]
    },
    generation_config: {
      mode: "ai",
      style: "заботливый",
      use_rag: true,
      guardrails: ["standard", "extra_negative_check"]
    },
    brands: ["Art-Visage", "Estrade"],
    sources: ["wildberries", "ozon"],
    matched_count: 12,
    last_matched_at: "2025-10-30T12:55:00Z",
    created_by: "user-1",
    created_at: "2025-10-20T10:00:00Z",
    updated_at: "2025-10-20T10:00:00Z",
  },
  {
    id: "strat-8",
    name: "Fallback: все остальные",
    description: "Стратегия по умолчанию для всех отзывов, не попавших в другие категории",
    is_active: true,
    is_fallback: true,
    priority: 10,
    conditions: {},
    generation_config: {
      mode: "ai",
      style: "профессиональный",
      use_rag: true
    },
    brands: ["Art-Visage", "Estrade"],
    sources: ["wildberries", "ozon"],
    matched_count: 5,
    last_matched_at: "2025-10-29T09:20:00Z",
    created_by: "user-1",
    created_at: "2025-10-20T10:00:00Z",
    updated_at: "2025-10-20T10:00:00Z",
  },
];
